import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './App.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    title: 'New Contact Submission',
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const [locationInfo, setLocationInfo] = useState('Unknown');
  const [isSending, setIsSending] = useState(false);

  // Fetch region info using IP
  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((res) => res.json())
      .then((data) => {
        const location = `${data.city}, ${data.region}, ${data.country_name}`;
        setLocationInfo(location);
      })
      .catch(() => setLocationInfo('Unavailable'));
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit form and send email
  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const timestamp = new Date().toLocaleString();

    try {
      await emailjs.send(
        'service_4lqbgz5',        // EmailJS service ID
        'template_bvsrqkd',      // EmailJS template ID
        {
          ...formData,
          time: timestamp,
          region: locationInfo,
        },
        'qhj_--VRR6xR3YS0-'        // EmailJS public key
      );

      alert('✅ Message sent successfully!');
      setFormData({
        title: 'New Contact Submission',
        name: '',
        email: '',
        subject: '',
        message: '',
      });
    } catch (error) {
      console.error('EmailJS error:', error);
      alert('❌ Message failed to send. Please try again later.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="contact-form">
      <form onSubmit={sendEmail}>
        <div className="form-group">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <button type="submit" className="submit-button" disabled={isSending}>
          {isSending ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
